<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
				<h1>Empty Page</h1>
				<p>Use this page to start from scratch and place your custom content.</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {

}
</script>

<style scoped>

</style>